var _g, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInsuranceNeed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 14271",
    fill: "none",
    stroke: "#197aba",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11722",
    d: "M20.053 12.474a8.527 8.527 0 11-8.527-8.526"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11723",
    d: "M16.263 12.474a4.737 4.737 0 11-4.737-4.737"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11724",
    d: "M18.158 3l-2.842 2.842v2.842h2.842L21 5.842l-1.9-.947z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11725",
    d: "M15.32 8.68l-3.79 3.79"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11726",
    d: "M0 0h24v24H0z",
    fill: "none"
  })));
}

export default SvgInsuranceNeed;


//////////////////
// WEBPACK FOOTER
// ./src/icons/insuranceNeed.svg
// module id = 894
// module chunks = 101